/* eslint-disable */
import * as d3Selection from 'd3-selection';
import View from './view';
import Utils from '../utils';

export default class OverlayView extends View {
  constructor(controller, container, config) {
      super(controller, container, config);

      // required
      this.ctaText = this.config.ctaText;
      this.closeText = this.config.closeText;
      this.overlayClassName = 'map__overlay';
      this.overlayCloseButton = 'map__overlay--close-button';
      this.hidden = 'map__overlay-hidden';
      this.mobileCTAClass = 'map__mobile-cta';
      this.isRendered = false;

      controller.addTopicHandler('enter-full-screen', this.hideOverlay.bind(this));
      controller.addTopicHandler('exit-full-screen', this.showOverlay.bind(this));
    }

  hideOverlay() {
    this.mapOverlay.classList.add(this.hidden);
    this.closeButton.classList.remove(this.hidden);
  }

  showOverlay() {
    this.closeButton.classList.add(this.hidden);
    this.mapOverlay.classList.remove(this.hidden);
  }

  renderCta() {
    const ctaElement = document.createElement('button');
    ctaElement.classList.add(this.overlayClassName);

    const ctaTextSpanWrapper = document.createElement('span');
    ctaTextSpanWrapper.classList.add(`${this.overlayClassName}__text-wrapper`);
    ctaElement.appendChild(ctaTextSpanWrapper);

    const ctaText = document.createElement("span");
    ctaText.classList.add(`${this.overlayClassName}__text-area`);
    ctaText.innerHTML = `${this.ctaText}`;
    ctaTextSpanWrapper.appendChild(ctaText);

    this.container.appendChild(ctaElement);
    ctaElement.addEventListener('click', () => {
        this.emit.call(this, 'enter-full-screen');
    });
  }

  renderClose() {
    const closeButton = document.createElement('button');
    closeButton.classList.add('map-view__button');
    closeButton.classList.add(this.overlayCloseButton);
    closeButton.innerHTML = this.closeText;
    this.container.parentNode.appendChild(closeButton);

    closeButton.addEventListener('click', () => {
        this.emit.call(this, 'exit-full-screen');
    });
  }

  render() {
    if (!this.isRendered) {
      this.container.parentNode.classList.add(this.mobileCTAClass);
      this.renderCta();
      this.renderClose();
      this.closeButton = document.querySelector(`.${this.overlayCloseButton}`);
      this.closeButton.classList.add(this.hidden);
      this.mapOverlay = document.querySelector(`.${this.overlayClassName}`);
    }
    this.isRendered = true;
  }
}
